// extracted by mini-css-extract-plugin
export default {"container":"cssf8v1z1","error":"csju4t0wx","placeholder":"ceqny27r8","transparent":"ccdwzcdsr","default":"cniiya8bt"};